import apiClient from '../client';

export type WriteAssistantType = 'headline' | 'bio' | 'client_bio' | 'project_description';

export interface WriteAssistantContext {
  currentText?: string;
  tone?: 'professional' | 'direct' | 'friendly' | 'casual' | 'formal' | 'conversational';
  size?: 'concise' | 'moderate' | 'elaborate' | 'detailed';
  customInstructions?: string;
  previousGeneratedText?: string;
  iterationPrompt?: string;
  projectTitle?: string;
  projectUrl?: string;
}

export interface WriteAssistantResponse {
  text: string;
  type: WriteAssistantType;
}

export interface WriteAssistantRequest {
  type: WriteAssistantType;
  context?: WriteAssistantContext;
}

/**
 * Generate text using AI write assistant
 */
export async function generateText(
  type: WriteAssistantType,
  context?: WriteAssistantContext
): Promise<WriteAssistantResponse> {
  const response = await apiClient.post<WriteAssistantResponse>('/ai/write-assistant', {
    type,
    context,
  }) as unknown as WriteAssistantResponse;
  return response;
}

export const aiService = {
  generateText,
};
